import axios from "axios";

const baseURL =
  (process.env.VUE_APP_API_URI ? process.env.VUE_APP_API_URI : "") +
  (process.env.VUE_APP_API_BASE_PATH
    ? process.env.VUE_APP_API_BASE_PATH
    : "/api/v1");
const axiosInstance = axios.create({ baseURL });

export default axiosInstance;